import { State } from 'src/types'
import { fingerStand } from '../fingerStand'
import { beltStyleDrawer } from './beltStyleDrawer'
import { regularStyleDrawer } from './regularStyleDrawer'

export const backStyleDrawer = async (ctx: CanvasRenderingContext2D, state: State): Promise<void> => {
  await fingerStand(ctx, state.fingerStand?.color, state.stitch?.color, state.printLeatherType?.value)
  // ベルトバックスタイル
  await beltStyleDrawer(ctx, state, state.printLeatherType?.value)
  // レギュラーバックスタイル
  await regularStyleDrawer(ctx, state, state.printLeatherType?.value)
}
